const statusOptions = [
  'shipped',
  'delivered',
  'cancelled',
];

const statusColors = {
  processing: 'bg-yellow-100 text-yellow-700 border-yellow-300',
  confirmed: 'bg-blue-100 text-blue-700 border-blue-300',
  shipped: 'bg-indigo-100 text-indigo-700 border-indigo-300',
  out_for_delivery: 'bg-purple-100 text-purple-700 border-purple-300',
  delivered: 'bg-green-100 text-green-700 border-green-300',
  cancelled: 'bg-red-100 text-red-700 border-red-300',
};

const countReturns = (order) =>
  (order.items || []).reduce((n, it) => (it.returnRequest ? n + 1 : n), 0);

const formatStatusLabel = (s) =>
  s.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export { statusOptions, statusColors, countReturns, formatStatusLabel };
